export const ignoredGovernanceTypes = {
  constant: true,
  concatenation: true,
  autofill: true,
  'link-validation': true,
}
